import { render, staticRenderFns } from "./OverviewPaybox.vue?vue&type=template&id=34ffeded&scoped=true&"
import script from "./OverviewPaybox.vue?vue&type=script&lang=js&"
export * from "./OverviewPaybox.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPaybox.vue?vue&type=style&index=0&id=34ffeded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffeded",
  null
  
)

export default component.exports